import { render, staticRenderFns } from "./ImportFicha.vue?vue&type=template&id=5049406a&scoped=true&"
import script from "./ImportFicha.vue?vue&type=script&lang=js&"
export * from "./ImportFicha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049406a",
  null
  
)

export default component.exports